import { Box, Typography } from '@mui/material'
import { FC, MouseEventHandler } from 'react'
import { MapboxFeature } from '../../types/Address'

interface SuggestionItemProps {
  handleClick: MouseEventHandler
  data: MapboxFeature
}


export const SuggestionItem: FC<SuggestionItemProps> = ({handleClick, data}) => {
  const formatAddressParts = (place_name: string) => {
    const parts = place_name.split(', ')
    const mainAddress = parts[0]
    const secondaryInfo = parts.slice(1).join(', ')
    return { mainAddress, secondaryInfo }
  }
  const { mainAddress, secondaryInfo } = formatAddressParts(data.place_name)

  return (
    <Box
      key={data.id}
      sx={{
        p: 2,
        cursor: 'pointer',
        '&:hover': {
          bgcolor: '#F8FAFC',
        },
        '&:not(:last-child)': {
          borderBottom: '1px solid #E2E8F0',
        },
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
      }}
      onClick={handleClick}
    >
      <Typography
        sx={{
          fontWeight: 600,
          color: '#1E293B',
          fontSize: '14px',
          lineHeight: '20px',
        }}
      >
        {mainAddress}
      </Typography>
      <Typography
        sx={{
          color: '#64748B',
          fontSize: '13px',
          lineHeight: '18px',
        }}
      >
        {secondaryInfo}
      </Typography>
    </Box>
  )
}
